import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import Header from './Header'

const mapStateToProps = state => ({
  user: state.user
})

export default withRouter(connect(
  mapStateToProps
)(Header))



// WEBPACK FOOTER //
// ./src/components/Layout/Header/index.js